/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import {useFormik} from 'formik'
import makeAnimated from 'react-select/animated'
import * as Yup from 'yup'
import axios from 'axios'
import Swal from 'sweetalert2'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../styles/styles'
import {Input3} from '../../../../../../components/Forms/Input'
import {
  IndemnityArea,
  IndemnityAreaInitValues as initialValues,
} from '../indemnityItems-list/core/_models'
import {useQueryClient} from 'react-query'
import CurrencyInput from 'react-currency-input-field'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

type Props = {
  show: boolean
  handleClose: () => void
  id: string
  propertyData: any
}
const propertiesSchema = Yup.object().shape({})
const API_URL = process.env.REACT_APP_API_URL || 'api'

const ModalAddIdemminityArea: React.FC<Props> = ({show, handleClose, id, propertyData}) => {
  const intl = useIntl()
  const queryClient = useQueryClient()
  const animatedComponents = makeAnimated()
  const [loading, setLoading] = useState(false)

  const [amountValue, setAmountValue] = useState(0)

  const propertyUuid = propertyData.data.property.uuid

  const loadOptionsIndemnityItems = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getOwners()
      let owners: any = []
      async function getOwners() {
        const {data} = await axios.get(
          `${API_URL}/sgt/v1/indemnity_items/select2?property_uuid=${propertyUuid}`
        )

        let Response = data.results
        console.log('Response select2', Response)
        if (Response) {
          for (const element of Response) {
            const owner: any = {
              value: element.id,
              label: element.text,
              outgoingProfitValue: element.outgoing_profit_value,
              directDamageValue: element.direct_damage_value,
              singlePaymentValue: element.single_payment_value,
            }
            owners.push(owner)
          }
        }
      }
      callback(owners)
    }, 2000)
  }

  const handleInputChangeIndemnityItems = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    console.log('inputValue', event)
    formik.setFieldValue('indemnity_item_id', inputValue)
    formik.setFieldValue('unitary_value', parseFloat(event.outgoingProfitValue))
    formik.setFieldValue('quantity', '')
    soma(0)
    setAmountValue(event.outgoingProfitValue)
    return {inputValue}
  }

  const formik = useFormik<IndemnityArea>({
    initialValues,
    validationSchema: propertiesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.post(
          `${API_URL}/sgt/v1/evaluation_reports/${propertyData.data.uuid}/evaluation_indemnity_areas`,
          values
        )
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'INDEMNITY_ITEM.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        queryClient.invalidateQueries('evaluation-indemnity-areas-list-page=1&items_per_page=10')
        handleClose()
        formik.resetForm()
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'INDEMNITY_ITEM.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
        formik.resetForm()
        handleClose()
      }
    },
  })

  function soma(quant: any) {
    let result = amountValue * quant
    const formCurrency = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(result)
    formik.setFieldValue('amount', result)
    return formCurrency
  }

  const closeModal = () => {
    handleClose()
    formik.resetForm()
  }
  return (
    <Modal
      id={id}
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-600px h-auto'
      show={show}
      onHide={closeModal}
    >
      <div className='container-xxl p-5'>
        <div className='modal-header py-2 d-flex justify-align-content-between border-0'>
          {/* begin::Close */}
          <span className='fw-bold fs-4 '>
            {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.TITLE_HEADER'})}
          </span>
          <div className='btn btn-icon btn-sm btn-light-primary' onClick={closeModal}>
            <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='col-lg-12'>
                <div className='row'>
                  {/* INICIO NOME PROPRIEDADE */}

                  <input
                    type='text'
                    className='d-none form-control-lg form-control-solid mb-3 mb-lg-0'
                    // placeholder={intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})}
                  />
                  {formik.touched.property_uuid && formik.errors.property_uuid && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.property_uuid}</div>
                    </div>
                  )}

                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM.ADD_BUTTON'})}
                    </label>

                    <div className='col-lg-12'>
                      <div className='row'>
                        <AsyncSelect
                          className='form-control form-control-lg form-control-solid p-1 ps-3'
                          styles={colourStyles}
                          components={animatedComponents}
                          cacheOptions
                          loadOptions={loadOptionsIndemnityItems}
                          filterOption={(option, inputValue) =>
                            option.label
                              ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                              : false
                          }
                          defaultOptions
                          onChange={handleInputChangeIndemnityItems}
                          placeholder={intl.formatMessage({
                            id: 'INDEMNITY_ITEM.TITLE',
                          })}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                            },
                          })}
                        />
                      </div>
                    </div>
                    {/* FIM NOME PROPRIEDADE */}

                    {/* INICIO NOME PORCENTAGEM */}
                    <div className='row'>
                      <Input3
                        title={intl.formatMessage({id: 'COMMON.YEARS'})}
                        placeholder={intl.formatMessage({id: 'COMMON.YEARS'})}
                        type='number'
                        {...formik.getFieldProps('years')}
                      />
                      <Input3
                        title={intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.QUANTITY'})}
                        placeholder={intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.QUANTITY'})}
                        type='number'
                        {...formik.getFieldProps('quantity')}
                        onChange={(e: any) => {
                          formik.setFieldValue('quantity', e.target.value)
                          soma(e.target.value)
                        }}
                      />
                      <Input3
                        title={intl.formatMessage({id: 'COMMON.VALUE_UNIT'})}
                        placeholder={intl.formatMessage({id: 'COMMON.VALUE_UNIT'})}
                        type='number'
                        {...formik.getFieldProps('unitary_value')}
                      />

                      <label className={`col-form-label fw-bold fs-6`}>
                        {intl.formatMessage({id: 'COMMON.AMOUNT_VALUE'})}
                      </label>

                      <input
                        type='text'
                        className='form-control form-control-lg form-control text-gray-400'
                        disabled
                        size={100}
                        {...formik.getFieldProps('amount')}
                      />
                    </div>

                    <label className='col-lg-12 col-form-label  fw-bold fs-6'>
                      {intl.formatMessage({id: 'COMMON.AMOUNT_VALUE'})}
                    </label>
                    <CurrencyInput
                      className='form-control form-control-lg form-control-solid'
                      {...formik.getFieldProps('amount')}
                      intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                      decimalScale={0}
                      allowDecimals={true}
                      onValueChange={(value) => formik.setFieldValue('amount', value || 0)}
                      placeholder={intl.formatMessage({id: 'COMMON.AMOUNT_VALUE'})}
                    />

                    {/* Submit */}
                    <div className='d-flex justify-content-end py-6'>
                      <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                        {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                        {loading && (
                          <span className='indicator-progress' style={{display: 'block'}}>
                            {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                    {/* ----------------------------------------------------------------------------------- */}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddIdemminityArea}
